<template>
  <div class="summary-card-preview" data-test-id="summary-card-live-preview">
    <div class="summary-card-preview__intro">
      <Typography variant="h-5">Live Preview</Typography>
      <Typography variant="body-2">
        Colors and branding can be customized in Account Management → Customization → Program
        Dashboard.
      </Typography>
    </div>
    <ProgramSummaryCard
      :program="previewProgram"
      :earnings="earningsValue"
      :basis="basis"
      :is-dollar-budget="isDollarBudget"
      preview
      stacked
    />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import ProgramSummaryCard from "@/components/participant/programs/ProgramSummaryCard.vue";
import { toPreviewRows } from "./metricPreview";

export default {
  name: "SummaryCardMetricStepPreview",
  components: { Typography, ProgramSummaryCard },
  props: {
    name: {
      type: String,
      default: "",
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
    imageUrl: {
      type: String,
      default: null,
    },
    payoutCadence: {
      type: String,
      default: null,
    },
    // Configured ProgramSummaryMetricRows, straight off the step.
    rows: { type: Array, default: () => [] },
    metricProjection: { type: Object, default: null },
    // ADO 190983: parity with DetailPageMetricsStepPreview.
    isDollarBudget: { type: Boolean, default: false },
  },
  computed: {
    basis() {
      return this.payoutCadence === "IMMEDIATE" ? "PAID" : "PROJECTED";
    },
    previewProgram() {
      return {
        displayName: this.name,
        name: this.name,
        startDate: this.startDate,
        endDate: this.endDate,
        imageURL: this.imageUrl,
        type: "dynamic-data",
        summaryMetricRows: this.rows,
        // The user summary returns the metric node alongside the rows.
        summaryMetric: this.metricProjection,
      };
    },
    previewRows() {
      return toPreviewRows(this.rows, this.metricProjection);
    },
    earningsValue() {
      // Rows/columns are reorderable and individually deletable, so the earnings
      // metric can land in any slot — search all rows/columns for the flagged one.
      for (const row of this.previewRows) {
        const earningsColumn = (row.columns || []).find((c) => c.isEarnings);
        if (earningsColumn) return earningsColumn.metric?.value ?? 0;
      }
      return 0;
    },
  },
};
</script>

<style scoped>
.summary-card-preview {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  text-align: left;
}

.summary-card-preview__intro {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
</style>
